import MasterData from '@/js/services/contracts/MasterData';

const mapCropToERP = (crop) => {
  const DataComplementary = [];
  const codes = Object.keys(crop.dcs);
  codes.forEach((code) => {
    DataComplementary.push({
      Code: code,
      Value: crop.dcs[code],
    });
  });

  const cropERP = {
    Code: crop.id_external,
    Description: crop.name,
    Surface: crop.surface,
    FarmCode: crop.field.code,
    VarietyCode: crop.variety,
    PlantationDate: crop.plantationDate,
    DataComplementary,
  };

  return cropERP;
};

const mapERPCropToLocal = async (cropERP) => {
  const field = await MasterData.getByKey('fields', 'code', cropERP.field);
  if (field.length === 0) {
    return null;
  }

  const dcs = {};
  cropERP.dcs.forEach((dc) => {
    dcs[dc.code] = dc.value;
  });

  const crop = { ...cropERP };
  crop.id_external = crop.code;
  crop.field = field[0].id;
  crop.protocols = cropERP.protocols.split(',') || [];
  crop.protocols = crop.protocols.map((p) => Number.parseInt(p, 10));
  crop.dcs = dcs;
  crop.sync_status = 0;

  return crop;
};

export { mapCropToERP, mapERPCropToLocal };
